<template>
  <div class="black-record-consume">
    <section class="dining-summary">
      <div>
        <span>桌号</span>
        <strong>{{ deskCode.code || "未绑定" }}</strong>
      </div>
      <div>
        <span>人数</span>
        <strong>{{ currentPeople }}人</strong>
      </div>
    </section>

    <section v-if="unpaidItems.length" class="record-section">
      <header class="section-title">
        <h2>待支付</h2>
      </header>

      <article
        v-for="group in timeGroups"
        :key="group.id"
        class="unpaid-group"
      >
        <h3>— {{ group.name }} —</h3>
        <div
          v-for="item in group.items"
          :key="getUnpaidItemKey(item)"
          class="unpaid-item"
        >
          <img :src="item.PicUrl || placeholderImage" :alt="item.GoodsName" />
          <div>
            <strong>{{ item.GoodsName }}</strong>
            <span>{{ getUnpaidDescription(item) }}</span>
          </div>
          <aside>
            <strong>¥{{ formatMoney(item.Price) }}</strong>
            <span>{{ item.num }}</span>
          </aside>
        </div>
        <footer>
          <span>{{ group.count }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(group.total) }}</strong>
        </footer>
      </article>
    </section>

    <section class="record-section paid-section">
      <header class="section-title"><h2>已支付订单</h2></header>

      <div v-if="loading" class="state-message">订单加载中...</div>
      <div v-else-if="loadError" class="state-message">
        <p>{{ loadError }}</p>
        <button type="button" @click="loadOrderRecords">重新加载</button>
      </div>
      <div v-else-if="!paidOrders.length" class="state-message">暂无订单</div>

      <article
        v-for="order in paidOrders"
        v-else
        :key="order.Id"
        class="paid-order"
      >
        <h3>— 下单时间：{{ order.CreateTime }} —</h3>
        <div
          v-for="detail in order.Details || []"
          :key="detail.Id || detail.ProductId"
          class="unpaid-item"
        >
          <img
            :src="detail.ProductImage || placeholderImage"
            :alt="detail.ProductName"
          />
          <div>
            <strong>{{ detail.ProductName }}</strong>
            <span>{{
              [detail.Specification, detail.Remark].filter(Boolean).join(" · ")
            }}</span>
          </div>
          <aside>
            <strong>¥{{ formatMoney(detail.Price) }}</strong>
            <span>{{ detail.Quantity }}</span>
          </aside>
        </div>
        <footer>
          <span>{{ getFoodsCount(order.Details) }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(order.OrigMoney) }}</strong>
        </footer>
      </article>
    </section>

    <footer class="record-footer">
      <div class="record-total">
        <div>
          <span>待支付 共{{ unpaidCount }}份</span>
          <strong>¥{{ formatMoney(unpaidMoney) }}</strong>
        </div>
        <div>
          <span>已支付 共{{ paidTotalCount }}份</span>
          <strong>¥{{ formatMoney(paidTotalMoney) }}</strong>
        </div>
      </div>
      <button type="button" class="continue-button" @click="handleToMicropoint">
        继续加菜
      </button>
      <button
         v-if="unpaidItems.length&&this.pendingPayType===1"
        type="button"
        :disabled="isPaying"
        class="pay-button"
        @click="submitPayment"
      >
       {{ isPaying ? "支付中..." : "立即付款" }}
        
      </button>
    </footer>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { getPayedHistoryOrderList, payByhandkey } from "@/api/foodOrder";
import { handleLocalStorage, handleSessionStorage } from "@/utils";

export default {
  name: "BlackRecordConsume",
  data() {
    return {
      loading: false,
      loadError: "",
      diningRoomInfo:{},
      paidOrders: [],
      unpaidItems: [],
      unpaidOrderId: null,
      tabActive: "type",
      typeGroups: [],
      timeGroups: [],
      unpaidMoney: 0,
      unpaidCount: 0,
      showPayPopup: false,
      pendingPayType: 1,
      isPaying: false,
      vpnInfo: {},
      currentPeople: 1,
      deskCode:{},
      placeholderImage: require("@/assets/black-micropoint/recommend.jpg"),
      previousPageChromeTheme: null,
    };
  },
  computed: {
    ...mapState({
      storeOrderPeople: (state) => state.order.orderPeople,
    }),


    /**
     * 根据当前标签返回按类型或按时间聚合后的待支付菜品。
     *
     * @returns {Array<Object>} 当前标签需要渲染的分组。
     */
    visibleUnpaidGroups() {
      return this.tabActive === "time" ? this.timeGroups : this.typeGroups;
    },
    /**
     * 已支付消费明细的数量。
     *
     * @returns {number} 已支付消费明细数量。
     */
    paidTotalCount() {
      return this.paidOrders.reduce(
        (total, order) => total + this.getFoodsCount(order.Details),
        0
      );
    },
    /**
     * 已支付订单的总金额。
     *
     * @returns {number} 已支付订单金额。
     */
    paidTotalMoney() {
      return this.paidOrders.reduce(
        (total, order) => total + this.normalizePrice(order.OrigMoney),
        0
      );
    },
  },
  created() {
    this.applyPageChromeTheme();
    this.initializePage();
  },
  beforeDestroy() {
    this.restorePageChromeTheme();
  },
  methods: {
    /**
     * 初始化人数、门店并加载历史订单。
     * 读取方式与 RecordsConsumption.vue 保持一致。
     *
     * @returns {void}
     */
    initializePage() {
      this.deskCode =  handleSessionStorage.get("deskCode") || {code: "",cardCode: "",checkinId: "",}
      this.vpnInfo = handleSessionStorage.get("vpnInfo") || {};
      this.currentPeople = Math.max(1, Number(this.storeOrderPeople) || 1);
       this.diningRoomInfo =handleSessionStorage.get("diningRoomInfo") || {};
       this.pendingPayType =  Number(this.diningRoomInfo.PayMode) || 1;
      this.loadOrderRecords();
    },
    /**
     * 请求历史订单并按原页面状态规则拆分：
     * Status 为 1 或 5 归入已支付，Status 为 0 归入待支付。
     * 待支付订单会继续展开 Details，供按类型和时间聚合。
     *
     * @returns {Promise<void>} 历史订单加载结束后完成。
     */
    async loadOrderRecords() {
      this.loading = true;
      this.loadError = "";
      try {
        const response = await getPayedHistoryOrderList({
          vpnId: this.vpnInfo.id,
          keyCode: this.deskCode.cardCode,
          tableCode: this.deskCode.code,
        });
        const records = Array.isArray(response) ? response : [];
        const paidOrders = [];
        const unpaidOrders = [];
        records.forEach((order) => {
          if (Number(order.Status) === 1 || Number(order.Status) === 5) {
            paidOrders.push(order);
          } else if (Number(order.Status) === 0) {
            unpaidOrders.push(order);
            this.unpaidOrderId = order.Id;
          }
        });
        this.paidOrders = paidOrders;
        this.normalizeUnpaidOrders(unpaidOrders);
      } catch (error) {
        this.paidOrders = [];
        this.unpaidItems = [];
        this.typeGroups = [];
        this.timeGroups = [];
        this.unpaidMoney = 0;
        this.unpaidCount = 0;
        this.loadError = "订单加载失败，请稍后重试";
      } finally {
        this.loading = false;
      }
    },
    /**
     * 展开全部待支付订单的 Details，并计算总金额与总数量。
     * 字段映射与 RecordsConsumption.vue 保持一致。
     *
     * @param {Array<Object>} unpaidOrders 待支付订单数组。
     * @returns {void}
     */
    normalizeUnpaidOrders(unpaidOrders) {
      const items = [];
      let totalMoney = 0;
      let totalCount = 0;
      unpaidOrders.forEach((order) => {
        totalMoney += this.normalizePrice(order.OrigMoney);
        (order.Details || []).forEach((detail) => {
          const quantity = Math.max(0, Number(detail.Quantity) || 0);
          totalCount += quantity;
          items.push({
            ProductId: detail.ProductId,
            GoodsName: detail.ProductName,
            PicUrl: detail.ProductImage,
            num: quantity,
            Price: this.normalizePrice(detail.Price),
            Remark: detail.Remark || "",
            ProductType: detail.ProductType || "精选菜品",
            CreateTime: detail.CreateTime || order.CreateTime,
            Name: detail.Specification || "",
          });
        });
      });
      this.unpaidItems = items;
      this.unpaidMoney = totalMoney;
      this.unpaidCount = totalCount;
      this.typeGroups = this.buildUnpaidGroups(items, "type");
      this.timeGroups = this.buildUnpaidGroups(items, "time");
    },
    /**
     * 按菜品类型或下单时间聚合待支付菜品。
     * 同一组内商品 id、规格和价格相同的条目会合并数量与备注。
     *
     * @param {Array<Object>} items 待支付菜品。
     * @param {"type"|"time"} mode 聚合模式。
     * @returns {Array<Object>} 页面可直接渲染的分组列表。
     */
    buildUnpaidGroups(items, mode) {
      const groups = new Map();
      items.forEach((sourceItem) => {
        const item = { ...sourceItem };
        const rawGroupKey =
          mode === "time" ? item.CreateTime : item.ProductType;
        const groupKey = rawGroupKey || "其他";
        if (!groups.has(groupKey)) {
          groups.set(groupKey, {
            id: `${mode}_${groupKey}`,
            name: mode === "time" ? `下单时间：${groupKey}` : groupKey,
            items: [],
            count: 0,
            total: 0,
          });
        }
        const group = groups.get(groupKey);
        const existing = group.items.find(
          (current) =>
            current.ProductId === item.ProductId &&
            current.Name === item.Name &&
            current.Price === item.Price
        );
        if (existing) {
          existing.num += item.num;
          existing.Remark = [existing.Remark, item.Remark]
            .filter(Boolean)
            .join(";");
        } else {
          group.items.push(item);
        }
        group.count += item.num;
        group.total += item.num * item.Price;
      });
      return Array.from(groups.values());
    },
    /**
     * 切换待支付订单的聚合方式。
     *
     * @param {"type"|"time"} tab 标签名称。
     * @returns {void}
     */
    changeTab(tab) {
      this.tabActive = tab;
    },
    /**
     * 生成待支付商品行的稳定渲染 key。
     *
     * @param {Object} item 待支付菜品。
     * @returns {string} 商品、规格、价格和时间组合键。
     */
    getUnpaidItemKey(item) {
      return [
        item.ProductId,
        item.Name,
        item.Price,
        item.CreateTime,
      ].join("_");
    },
    /**
     * 组合待支付菜品的规格与备注。
     *
     * @param {Object} item 待支付菜品。
     * @returns {string} 菜品辅助描述。
     */
    getUnpaidDescription(item) {
      return [item.Name, item.Remark].filter(Boolean).join(" · ");
    },
    /**
     * 汇总已支付订单中的菜品数量。
     *
     * @param {Array<Object>} details 已支付订单详情。
     * @returns {number} Quantity 合计。
     */
    getFoodsCount(details) {
      return (details || []).reduce(
        (total, item) => total + (Number(item.Quantity) || 0),
        0
      );
    },
    /**
     * 将金额转换成有限数字。
     *
     * @param {number|string|null|undefined} value 原始金额。
     * @returns {number} 可安全计算的金额。
     */
    normalizePrice(value) {
      const amount = Number(
        String(value == null ? "" : value).replace(/[¥,\s]/g, "")
      );
      return Number.isFinite(amount) ? amount : 0;
    },
    /**
     * 格式化金额，整数不显示小数，其他金额最多保留两位。
     *
     * @param {number|string} value 金额。
     * @returns {string} 展示文本。
     */
    formatMoney(value) {
      return this.normalizePrice(value)
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\.\d)0$/, "$1");
    },
    /**
     * 按原记录页逻辑提交支付。
     * 手牌挂账调用 payByhandkey；在线支付进入 PayList 页面。
     *
     * @returns {Promise<void>} 支付处理结束后完成。
     */
    async submitPayment() {

      console.log("submitPayment==== "+this.pendingPayType)
      if (this.isPaying || !this.unpaidOrderId) return;
      if (this.pendingPayType === 2 && !this.deskCode.cardCode) {
        this.$toast("暂未绑定手牌，请先绑定手牌");
        return;
      }
      if (this.pendingPayType === 1) {
        this.$router.push({
          name: "PayList",
          query: { id: this.unpaidOrderId, fromPage: "food" },
        });
        return;
      }
      this.isPaying = true;
      try {
        await payByhandkey({
          OrderId: this.unpaidOrderId,
          KeyCode: this.deskCode.cardCode,
          CheckinId: this.deskCode.checkinId,
        });
        this.showPayPopup = false;
        this.$router.replace({ name: "PlaceOrderSuccess" });
      } catch (error) {
        this.$toast("支付失败："+error);
      } finally {
        this.isPaying = false;
      }
    },
    /**
     * 查看已支付订单详情。
     * 与 RecordsConsumption.vue 一致，先写入 foodItemInfo 再进入详情页。
     *
     * @param {Object} order 已支付订单。
     * @returns {void}
     */
    handleToOrderDetail(order) {
      handleLocalStorage.set("foodItemInfo", order);
      this.$router.push({ name: "FoodOrderInfo" });
    },
    /**
     * 返回黑色点餐页继续加菜。
     *
     * @returns {void}
     */
    handleToMicropoint() {
      this.$router.push({ name: "BlackMicropoint" });
    },
    /**
     * 应用深色页面背景，避免页面回弹或安全区出现白色。
     *
     * @returns {void}
     */
    applyPageChromeTheme() {
      this.previousPageChromeTheme = {
        htmlBackground: document.documentElement.style.backgroundColor,
        bodyBackground: document.body.style.backgroundColor,
      };
      document.documentElement.style.backgroundColor = "#171717";
      document.body.style.backgroundColor = "#171717";
    },
    /**
     * 离开页面时恢复进入前的页面背景。
     *
     * @returns {void}
     */
    restorePageChromeTheme() {
      if (!this.previousPageChromeTheme) return;
      document.documentElement.style.backgroundColor =
        this.previousPageChromeTheme.htmlBackground;
      document.body.style.backgroundColor =
        this.previousPageChromeTheme.bodyBackground;
    },
  },
};
</script>

<style scoped lang="scss">
.black-record-consume {
  min-height: 100vh;
  padding: 28px 24px calc(112px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #f7f4ee;
  background-color: #202120;
  background-image: url("~@/assets/black-micropoint/bg.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.dining-summary {
  display: flex;
  gap: 24px;
  margin-bottom: 22px;

  > div {
    display: flex;
    height: 70px;
    padding: 0 22px;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(226, 187, 91, 0.25);
    border-radius: 5px;
    background: rgba(35, 35, 35, 0.78);
    font-size: 22px;

    strong {
      color: #d8d5cd;
      font-size: 21px;
      font-weight: 400;
    }
  }
}

.record-section {
  margin-bottom: 26px;
}

.section-title {
  display: flex;
  min-height: 62px;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    font-size: 28px;
  }
}

.record-tabs {
  display: flex;
  gap: 24px;

  button {
    position: relative;
    padding: 8px 0;
    border: 0;
    color: #99958d;
    background: transparent;
    font-size: 20px;

    &.active {
      color: #f1c85f;
    }

    &.active::after {
      position: absolute;
      right: 3px;
      bottom: 0;
      left: 3px;
      height: 3px;
      border-radius: 2px;
      background: #edc45c;
      content: "";
    }
  }
}

.unpaid-group,
.paid-order {
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(226, 187, 91, 0.2);
  border-radius: 10px;
  background: rgba(30, 30, 30, 0.82);
}

.unpaid-group {
  border-color: #383e50;
  background: #383e50;

  h3 {
    margin: 0 0 12px;
    color: #f0c75d;
    font-size: 22px;
    text-align: center;
  }

  > footer {
    display: flex;
    padding-top: 14px;
    justify-content: flex-end;
    color: #aaa69f;
    font-size: 18px;

    strong {
      margin-left: 6px;
      color: #f1ca63;
    }
  }
}

.unpaid-item {
  display: flex;
  min-height: 102px;
  padding: 12px 0;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  > img {
    width: 82px;
    height: 82px;
    border-radius: 6px;
    object-fit: cover;
  }

  > div {
    display: flex;
    min-width: 0;
    margin-left: 14px;
    flex: 1;
    flex-direction: column;

    strong {
      overflow: hidden;
      font-size: 21px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      margin-top: 7px;
      overflow: hidden;
      color: #aaa69f;
      font-size: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  aside {
    display: flex;
    margin-left: 12px;
    align-items: flex-end;
    flex-direction: column;

    strong {
      color: #f1ca63;
      font-size: 20px;
    }

    span {
      margin-top: 10px;
      color: #bbb7ae;
      font-size: 18px;
    }
  }
}

.unpaid-total {
  display: flex;
  padding: 18px 8px 4px;
  justify-content: flex-end;
  color: #aaa69f;
  font-size: 20px;

  strong {
    margin-left: 7px;
    color: #f1ca63;
  }
}

.paid-order {
  border-color: #383e50;
  background: #383e50;

  h3 {
    margin: 0 0 12px;
    color: #f0c75d;
    font-size: 22px;
    text-align: center;
  }

  > footer {
    display: flex;
    padding-top: 14px;
    justify-content: flex-end;
    color: #aaa69f;
    font-size: 18px;

    strong {
      margin-left: 6px;
      color: #f1ca63;
    }
  }
}

.state-message {
  padding: 80px 20px;
  color: #999;
  text-align: center;

  p {
    margin: 0 0 18px;
  }

  button {
    height: 42px;
    padding: 0 20px;
    border: 1px solid #caa64e;
    border-radius: 5px;
    color: #e2bd60;
    background: transparent;
  }
}

.record-footer {
  position: fixed;
  z-index: 20;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(96px + env(safe-area-inset-bottom));
  padding: 0 24px env(safe-area-inset-bottom);
  align-items: center;
  gap: 16px;
  // border-top: 1px solid #d9aa49;
  background: #171817;

  .record-total {
    display: flex;
    min-width: 0;
    margin-right: auto;
    gap: 18px;

    > div {
      display: flex;
      flex-direction: column;

      span {
        color: #aaa69f;
        font-size: 15px;
        white-space: nowrap;
      }

      strong {
        margin-top: 4px;
        color: #f3ce69;
        font-size: 25px;
        line-height: 1;
      }
    }
  }

  button {
    width: 190px;
    height: 68px;
    padding: 0 24px;
    flex: 0 0 190px;
    border: 0;
    border-radius: 34px;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
    font-size: 27px;
    font-weight: 600;
  }

  .continue-button {
    border: 0;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
  }

  .pay-button {
    border: 0;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
    font-weight: 600;

    &:disabled {
      color: #777;
      background: #444;
    }
  }
}

.black-record-popup,
.pay-popup {
  color: #f6f2e9;
  background-color: #242524;
  background-image: url("~@/assets/black-micropoint/bg.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.black-record-popup {
  max-height: 82vh;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.pay-popup {
  min-height: 390px;

  > header {
    display: flex;
    min-height: 82px;
    padding: 0 26px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(226, 187, 91, 0.28);

    strong {
      font-size: 27px;
    }

    button {
      border: 0;
      color: #e1bd5d;
      background: transparent;
      font-size: 28px;
    }
  }

  > footer {
    display: flex;
    padding: 14px 24px calc(14px + env(safe-area-inset-bottom));
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(226, 187, 91, 0.28);

    div {
      display: flex;
      flex-direction: column;

      span {
        color: #aaa;
        font-size: 16px;
      }

      strong {
        color: #f2c85e;
        font-size: 28px;
      }
    }

    > button {
      height: 62px;
      padding: 0 42px;
      border: 0;
      border-radius: 6px;
      color: #2d230d;
      background: linear-gradient(90deg, #d6a640, #ffe78e);
      font-size: 23px;
      font-weight: 600;

      &:disabled {
        color: #777;
        background: #444;
      }
    }
  }
}

.pay-options {
  padding: 22px 24px;

  button {
    display: flex;
    width: 100%;
    height: 70px;
    padding: 0 20px;
    margin-bottom: 12px;
    align-items: center;
    border: 1px solid #555;
    border-radius: 6px;
    color: #f2eee6;
    background: rgba(48, 48, 48, 0.78);
    font-size: 21px;

    small {
      margin-left: auto;
      color: #999;
      font-size: 17px;
    }

    &.active {
      border-color: #edc45c;
      color: #f4ca60;
      background: #4b4029;
    }
  }
}
</style>
